import { type Variants, type Transition } from 'framer-motion';

/** Плавность как у аккордеона проекта (cubic-bezier 0.4, 0, 0.2, 1). */
export const TOAST_TRANSITION: Transition = {
  duration: 0.28,
  ease: [0.4, 0, 0.2, 1]
};

/**
 * Варианты появления/исчезновения тоста: выезд справа + лёгкий scale и fade.
 * Используются в `motion`-обёртке карточки внутри `AnimatePresence`.
 */
export const TOAST_VARIANTS: Variants = {
  initial: { opacity: 0, x: 40, scale: 0.96 },
  animate: { opacity: 1, x: 0, scale: 1 },
  exit: { opacity: 0, x: 40, scale: 0.96 }
};

/**
 * Варианты для карточки в панели уведомлений: мягкий fade со сдвигом вверх.
 * Та же плавность (`TOAST_TRANSITION`), что у тостов.
 */
export const PANEL_ITEM_VARIANTS: Variants = {
  initial: { opacity: 0, y: -6 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 }
};
